<div
  tappable
  @animatedVendorItem
  class="vendor-item"
  [class.unavailable]="vendorItem.availability !== Availability.Available"
  data-cy="vendor-item"
  (click)="onItemSelected()"
>
  <div class="vendor-item-image-aspect-ratio-wrapper">
    <div class="vendor-item-image-aspect-ratio-content">
      <div class="lazy-loading-image-container">
        <div #lazyLoadingImage [attr.data-src]="vendorItem.imageUrl" class="lazy-loading-image not-loaded animated-image">
          <div
            class="lazy-loading-image-content"
            [style.backgroundImage]="vendorItem.imageUrl ? 'url(' + vendorItem.imageUrl + ')' : null"
          ></div>
        </div>

        <div
          class="vendor-item-notice"
          data-cy="notice-period-warning-message"
          *ngIf="vendorItem.availability === Availability.Available && vendorItem.noticePeriodWarningMessage"
        >
          <ion-icon src="/assets/custom-icons/b-clock.svg"></ion-icon>
          <span>{{ vendorItem.noticePeriodWarningMessage }}</span>
        </div>

        <div class="item-unavailability" *ngIf="vendorItem.availability !== Availability.Available">
          <span class="item-unavailability-text">{{ "UNAVAILABLE" | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="vendor-item-info">
    <div class="details">
      <ng-container *ngIf="vendorItem.badges && vendorItem.badges[0]; let itemFirstBadge">
        <div class="vendor-item-badge" [style.color]="itemFirstBadge.foreColor" [style.backgroundColor]="itemFirstBadge.backColor">
          <ion-icon *ngIf="itemFirstBadge.iconUrl" class="vendor-item-badge-icon" [src]="itemFirstBadge.iconUrl"></ion-icon>
          {{ itemFirstBadge.text }}
        </div>
      </ng-container>

      <div class="vendor-item-name" data-cy="vendor-item-name">{{ vendorItem.name }}</div>

      <div class="vendor-item-description">
        {{ vendorItem.description }}
      </div>

      <div class="vendor-item-vendor-name">
        {{ "BY" | translate | lowercase }}

        <app-router-link
          stopPropagation
          [path]="isBrowser && vendorItem.vendorSlug ? ['vendors', vendorItem.vendorSlug] : ['vendors', 'id', vendorItem.vendorId]"
          [queryParams]="{ tagsIds: selectedTagsIds }"
          [preserveFragmentAndQueryParams]="true"
        >
          <span class="vendor-item-vendor-name-highlighted">{{ vendorItem.vendorName }}</span>
        </app-router-link>
      </div>

      <div class="vendor-item-price" *ngIf="vendorItem.availability === Availability.Available">
        <ng-container *ngIf="vendorItem.price">
          <span class="price">{{ vendorItem.price | localCurrency }}</span>
          <span class="retail" *ngIf="vendorItem.onSale">{{ vendorItem.retailPrice | localCurrency }}</span>
        </ng-container>

        <ng-container *ngIf="!vendorItem.price">
          <span class="price" *ngIf="!vendorItem.supportStartingPrice || !vendorItem.minimumCost">
            {{ "PRICE_ON_SELECTION" | translate }}
          </span>

          <ng-container *ngIf="vendorItem.supportStartingPrice && vendorItem.minimumCost">
            <span class="price"> {{ "FROM" | translate }} {{ vendorItem.minimumCost | localCurrency }} </span>
            <span class="retail min-cost" *ngIf="vendorItem.onSale">
              {{ "FROM" | translate }} {{ vendorItem.retailMinimumCost | localCurrency }}
            </span>
          </ng-container>
        </ng-container>
      </div>

      <div
        class="vendor-item-availability"
        *ngIf="vendorItem.availability !== Availability.Available"
        [style.color]="vendorItem.availabilityTextColor ? vendorItem.availabilityTextColor : '#e66363'"
      >
        {{ vendorItem.availabilityText }}
      </div>
    </div>
  </div>
</div>
